import { buildUncontrolledDataForMutation } from 'utils/constructEditDriverInfo';
import { resetTimestampToUtc } from 'utils/datetime';

/**
 * @typedef {Object} DriverInfo
 * @property {string} fullName
 * @property {string | null} phone
 * @property {string | null} startTime
 * @property {string | null} driverLicenseExpiresAt
 * @property {string | null} medicalCheckExpiresAt
 * @property {string | null} [email]
 * @property {string | null} [endTime]
 * @property {string | null} [drugTestExpiresAt]
 * @property {boolean} [isActive]
 * @property {import('./formatEffectiveDate').PermanentHomeBase | null} [permanentHomeBase]
 *
 * @typedef {Object} EditFormValues
 * @property {string} phone
 * @property {string} startTime
 * @property {string} driverLicenseExpiresAt
 * @property {string} medicalCheckExpiresAt
 */

/**
 * Empty string → null; otherwise convert to UTC via `resetTimestampToUtc`.
 *
 * @param {string} timeValue
 * @returns {string | null}
 */
export const setTimeValueForMutation = (timeValue) =>
	timeValue === '' ? null : resetTimestampToUtc(timeValue);

/**
 * Build the mutation `input` for `updateCrewMemberInfo` from form values +
 * the passthrough fields on the original driver record.
 *
 * @param {{ formValues: EditFormValues, driverInfo: DriverInfo }} args
 * @returns {Object}
 */
export const buildUpdateCrewMemberInput = ({ formValues, driverInfo }) => {
	const { phone, startTime, driverLicenseExpiresAt, medicalCheckExpiresAt } = formValues;
	return {
		...buildUncontrolledDataForMutation(driverInfo),
		phone: phone === '' ? null : phone,
		startTime: setTimeValueForMutation(startTime),
		driverLicenseExpiresAt: setTimeValueForMutation(driverLicenseExpiresAt),
		medicalCheckExpiresAt: setTimeValueForMutation(medicalCheckExpiresAt),
	};
};
